import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { z } from 'zod';

import { queryClient } from '../QueryApiProvider';

const schema = z.object({
  url: z.string().url(),
});

async function updateAvatar(
  address: string,
  body: FormData,
): Promise<{ url?: string }> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const data = await fetch(
    new URL(
      `/profile-image/${address}`,
      import.meta.env.VITE_TALKJS_URL,
    ).toString(),
    {
      method: 'POST',
      body,
    },
  ).then((res) => res.json());

  return schema.parse(data);
}

export function useAvatarMutation(
  address: string,
  onError: () => void,
): UseMutationResult<{ url?: string }, unknown, FormData> {
  return useMutation({
    mutationFn: (formData: FormData) => updateAvatar(address, formData),
    onSuccess: (result, variables, context) => {
      // Replace optimistic todo in the todos list with the result
      queryClient.setQueryData(['avatar', address], () => result);
    },
    onError,
  });
}
